import { MESSAGE_GET_CONFIG, UHID_GET_CONFIG } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = {
    success: boolean;
    data: {
        [key: string]: {
            title: string;
            summary: string;
            status: boolean;
            channels: string[];
            enabled_channels: string[];
        };
    };
    error?: string;
};

export default (docid: string): Promise<Res> => {
    return fetchWithRefresh(MESSAGE_GET_CONFIG(docid)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to MESSAGE_GET_CONFIG');
        }
    });
};
